import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DomSanitizer} from '@angular/platform-browser';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.css']
})
export class TermsDialogComponent implements OnInit {
  webViewSrc: any = '';
  url: string = '';
  api_url: string = environment.API_URL;
  TERM_AND_CONDITION: any;
  title: string;
  main_p: any;
  constructor(
    private sanitizer: DomSanitizer,
    private loadingService: LoadingService,
    private dialogRef: MatDialogRef<TermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { token: string, type: string}
    ) {
      this.url = `${this.api_url}term/${this.data.type}`;
     
      if (data?.type === 'payment') {
         this.title= TERM_CONDITION_PAYMENT.title;
         this.main_p= TERM_CONDITION_PAYMENT.main_p;
        this.TERM_AND_CONDITION=  TERM_CONDITION_PAYMENT.content ;
        
      } else {
        this.title= TERM_CONDITION_PAYMENT.title;
        this.TERM_AND_CONDITION= TERM_CONDITION_REGISTER.content;
      }
      
  }

  ngOnInit() {
    this.webViewSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  onAgree() {
    this.loadingService.setLoading(true);
    this.dialogRef.close(true);
  }
  click(): void {
    console.log("click");
  }
}

const TERM_CONDITION_PAYMENT =  {
  title: "TITLE",
  main_p: [
    "MAIN_P",
  ],
  content: [
   {
    title: "CONTENT.TITLE.ONE",
    p: [
      "CONTENT.POINT_ONE.ONE"
    ]
   },
   {
    title: "CONTENT.TITLE.TWO",
    p: [
      "CONTENT.POINT_TWO.ONE",
      "CONTENT.POINT_TWO.TWO",
      "CONTENT.POINT_TWO.DESC",
      "CONTENT.POINT_TWO.THREE",
      "CONTENT.POINT_TWO.FOUR",
      "CONTENT.POINT_TWO.FIVE",
      "CONTENT.POINT_TWO.SIX"
    ]
   },
   {
    title: "CONTENT.TITLE.THREE",
    desc: "CONTENT.POINT_TWO.DESC",
    type: "three",
    p: [
      "CONTENT.POINT_THREE.ONE",
      "CONTENT.POINT_THREE.TWO",
      "CONTENT.POINT_THREE.THREE",
      "CONTENT.POINT_THREE.FOUR",
      "CONTENT.POINT_THREE.FIVE",
    ]
   },
   {
    title: "CONTENT.TITLE.FOUR",
    p: [
      "CONTENT.POINT_FOUR.ONE"
    ]
   },
   {
    title: "CONTENT.TITLE.FIVE.TITLE",
    child: [
     {
      title: "CONTENT.TITLE.FIVE.FIVE_ONE",
      p: [
        "CONTENT.POINT_FIVE.FIVE_ONE.ONE",
        "CONTENT.POINT_FIVE.FIVE_ONE.TWO"
      ]
     },
     {
      title: "CONTENT.TITLE.FIVE.FIVE_TWO",
      p: [
        "CONTENT.POINT_FIVE.FIVE_TWO.ONE",
        "CONTENT.POINT_FIVE.FIVE_TWO.TWO",
        "CONTENT.POINT_FIVE.FIVE_TWO.THREE",
        "CONTENT.POINT_FIVE.FIVE_TWO.FOUR"
      ]
     }
    ]
  },
  {
    title: "CONTENT.TITLE.SIX.TITLE",
    child: [
      {
       title: "CONTENT.TITLE.SIX.SIX_ONE",
       p: ["CONTENT.POINT_SIX.SIX_ONE.ONE"]
      },
      {
       title: "CONTENT.TITLE.SIX.SIX_TWO",
       p: [
         "CONTENT.POINT_SIX.SIX_TWO.ONE",
         "CONTENT.POINT_SIX.SIX_TWO.TWO",
         "CONTENT.POINT_SIX.SIX_TWO.THREE"
       ]
      },
      {
        title: "CONTENT.TITLE.SIX.SIX_THREE",
        p: [
          "CONTENT.POINT_SIX.SIX_THREE.ONE",
          "CONTENT.POINT_SIX.SIX_THREE.TWO",
        ]
       }
     ]
   },
   {
    title: "CONTENT.TITLE.SEVEN",
    p: [
      "CONTENT.POINT_SEVEN.ONE"
    ]
  },
   {
    title: "CONTENT.TITLE.EIGHT",
    p: [
      "CONTENT.POINT_EIGHT.ONE"
    ]
  }
  ]
};

const TERM_CONDITION_REGISTER= {
    'title': 'TITLE',
    'content': [
      'REGISTRATION.CONTENT.ONE',
      'REGISTRATION.CONTENT.TWO',
      'REGISTRATION.CONTENT.THREE',
      'REGISTRATION.CONTENT.FOUR',
      'REGISTRATION.CONTENT.FIVE',
      'REGISTRATION.CONTENT.SIX',
      'REGISTRATION.CONTENT.SEVEN',
      'REGISTRATION.CONTENT.EIGHT',
      'REGISTRATION.CONTENT.NINE',
      'REGISTRATION.CONTENT.TEN',
      'REGISTRATION.CONTENT.ELEVEN',
      'REGISTRATION.CONTENT.TWELVE',
      'REGISTRATION.CONTENT.THIRTEEN',
      'REGISTRATION.CONTENT.FOURTEEN',
      'REGISTRATION.CONTENT.FIFTEEN'
  ]};